import { activeUserListConstants } from "../_constants";
import { alertActions } from "./alert.actions";
import {
  APIcallFunction,
  headerForPrivateAPI,
} from "../_helpers";

export const activeUserListAction = {
  activeUsersList,
  updateUserStatus,
  displayDashboardData,
};

function activeUsersList(data, details) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/user/getUserList",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        // dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return { type: activeUserListConstants.GET_ACTIVE_USER_LIST_REQUEST, user };
  }
  function success(user) {
    return { type: activeUserListConstants.GET_ACTIVE_USER_LIST_SUCCESS, user };
  }
  function failure(error) {
    return {
      type: activeUserListConstants.GET_ACTIVE_USER_LIST_FAILURE,
      error,
    };
  }
};
function updateUserStatus(data, details) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/updateUserStatus",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        dispatch(activeUserListAction.activeUsersList(details));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return { type: activeUserListConstants.UPDATE_USER_STATUS_REQUEST, user };
  }
  function success(user) {
    return { type: activeUserListConstants.UPDATE_USER_STATUS_SUCCESS, user };
  }
  function failure(error) {
    return { type: activeUserListConstants.UPDATE_USER_STATUS_FAILURE, error };
  }
};

function displayDashboardData(data, details) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/admin/dashboardDetailsData",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        // dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return { type: activeUserListConstants.GET_SHOWDASHBOARD_DATA_REQUEST, user };
  }
  function success(user) {
    return { type: activeUserListConstants.GET_SHOWDASHBOARD_DATA_SUCCESS, user };
  }
  function failure(error) {
    return {
      type: activeUserListConstants.GET_SHOWDASHBOARD_DATA_FAILURE,
      error,
    };
  }
};
